import { Component } from '@angular/core';
import { OpenIdConnectService } from '../../services/oidc/open-id-connect.service';
import { UnitOfWorkService } from '../../services/unitOfWork/unitOfWork.service';
import * as _util from '../../services/utilities';
import * as _errorHandler from '../../services/errorhandler';
import { ApplicationInsightsService } from '../../services/appInsights/application-insights.service';
import { FilterPipe } from "../../pipes/filter.pipe";
import { BusyService } from '../../services/busy.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
    public name: string;
    public workspaces: model.workspaceRightDto[];
    public query: string = '';

    handler = _errorHandler.includeIn(this);

    constructor(private uow: UnitOfWorkService, private oidcService: OpenIdConnectService, private ai: ApplicationInsightsService, private busy: BusyService) {
        ai.logPageView();

        this.name = this.oidcService.profile.name;

        this.busy.set({ key: 'ws-load', isBusy: true, message: 'Retrieving your workspaces' });
        uow.getWorkspaceRights()
            .then(data => {
                this.workspaces = data;
                for (var i = 0; i < this.workspaces.length; i++)
                    this.workspaces[i].url = '/browse/' + this.workspaces[i].library + '/' + this.workspaces[i].workspaceId;
                this.busy.set({ key: 'ws-load', isBusy: false });
            })
            .catch(reason => {
                this.busy.set({ key: 'ws-load', isBusy: false });
                this.handler.handleError(reason);
            });
    }

    filterWorkspace(ws: model.workspaceRight) {
        return ws.workspaceName.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
    }
}
